import {
  ChevronDown,
  ChevronUp
} from "./chunk-5VDSC7QK.mjs";

// src/multiselect/src/components/react-select-components/dropdown-indicator.tsx
import { components } from "react-select";
import { jsx } from "react/jsx-runtime";
var DropdownIndicator = (props) => {
  const { menuIsOpen } = props.selectProps;
  return /* @__PURE__ */ jsx(components.DropdownIndicator, { ...props, children: menuIsOpen ? /* @__PURE__ */ jsx(ChevronUp, {}) : /* @__PURE__ */ jsx(ChevronDown, {}) });
};

export {
  DropdownIndicator
};
